module.exports = __webpack_public_path__ + "img/data.ea6676a7.png";